import axios from 'axios'; // AJAX封装类
import * as qiniu from 'qiniu-js'
import { config } from '@/utils/config'; // 配置
import {
    post
} from '@/utils/http';
export default function(val) {
    // val数据类型是对象，调用该方法的时候传两个参数，file代表上传的文件，isSave代表上传的policyName参数是临时文件还是永久文件。

    // 获取文件上传token接口参数名policyName，可传入temporary（临时文件），permanent（永久文件）


    return new Promise((resolve, reject) => {
        // axios.defaults.baseURL = config.axios_normalURL; //请求normalURL

        post('/qiniu/getToken', { policyName: val.isSave }, {}, 'normal', this).then((res) => {

            // axios.defaults.baseURL = config.axios_baseURL; //请求base url

            //图片上传前压缩
            const options = {
                quality: 0.92,
                noCompressIfLarger: true
                    // maxWidth: 1000,
                    // maxHeight: 618
            }

            qiniu.compressImage(val.file, options).then(data => {


                const observable = qiniu.upload(val.file, config.qnKey, res.data);


                const observer = {
                    next(res) {
                        // ...

                        // console.log(res, 'res========');
                    },
                    error(err) {
                        // ...
                    },
                    complete(res) {

                        resolve(res);
                    }
                };
                const subscription = observable.subscribe(observer); // 上传开始
                // observable.subscribe(observer);
            });
        })
        // axios.defaults.baseURL = config.axios_baseURL; //请求base url
    })







}